export default __webpack_public_path__ + "static/media/step-8.a485ec5f.png";